'use client';

function getPrefix(key: string): string {
  return `CC_${key}`;
}

export class ClientStorage {
  static setLocalStorage(key: string, value: any): void {
    if (!key || !value || typeof Storage === 'undefined') return;

    const keyItem = getPrefix(key);

    localStorage.setItem(keyItem, JSON.stringify(value));
  }

  static getLocalStorage(key: string): any | null {
    if (!key || typeof Storage === 'undefined') return null;

    const keyItem = getPrefix(key);
    const val = localStorage.getItem(keyItem);

    if (val) {
      try {
        return JSON.parse(val);
      } catch {
        return null;
      }
    }

    return null;
  }

  static removeLocalStorage(key: string): void {
    if (!key || typeof Storage === 'undefined') return;

    const keyItem = getPrefix(key);

    localStorage.removeItem(keyItem);
  }

  static clearLocalStorage(): void {
    localStorage.clear();
  }

  static setSessionStorage(key: string, value: any): void {
    if (!key || !value || typeof Storage === 'undefined') return;

    const keyItem = getPrefix(key);

    sessionStorage.setItem(keyItem, JSON.stringify(value));
  }

  static getSessionStorage(key: string): any | null {
    if (!key || typeof Storage === 'undefined') return null;

    const keyItem = getPrefix(key);
    const val = sessionStorage.getItem(keyItem);

    if (val) {
      try {
        return JSON.parse(val);
      } catch {
        return null;
      }
    }

    return null;
  }

  static removeSessionStorage(key: string): void {
    if (!key || typeof Storage === 'undefined') return;

    const keyItem = getPrefix(key);

    sessionStorage.removeItem(keyItem);
  }

  static clearSessionStorage(): void {
    sessionStorage.clear();
  }
}
